import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cell = { padding: '12px 16px', fontSize: '0.82rem', color: '#333', borderBottom: '1px solid rgba(184,211,207,0.25)' };
const hcell = { ...cell, fontWeight: '700', fontSize: '0.72rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: '#9AADAB', background: 'rgba(184,211,207,0.12)' };

export default function AdminUsers() {
  const [secret, setSecret]   = useState('');
  const [authed, setAuthed]   = useState(false);
  const [users, setUsers]     = useState([]);
  const [waitlist, setWaitlist] = useState([]);
  const [stats, setStats]     = useState(null);
  const [tab, setTab]         = useState('users'); // users | waitlist
  const [loading, setLoading] = useState(false);
  const [search, setSearch]   = useState('');

  const load = async (s = secret) => {
    setLoading(true);
    try {
      const [uRes, wRes, sRes] = await Promise.all([
        axios.get(`${API}/admin/users?secret=${s}`),
        axios.get(`${API}/waitlist?secret=${s}`),
        axios.get(`${API}/admin/stats?secret=${s}`),
      ]);
      setUsers(uRes.data);
      setWaitlist(wRes.data);
      setStats(sRes.data);
      setAuthed(true);
    } catch {
      alert('Wrong secret or server error.');
    } finally {
      setLoading(false);
    }
  };

  if (!authed) return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#f5f8f7', gap: '16px', padding: '24px'
    }}>
      <p style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.2rem', color: '#1E6B68' }}>HYPSEYA Admin</p>
      <input
        type="password" placeholder="Admin secret"
        value={secret} onChange={e => setSecret(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && load()}
        style={{ padding: '12px 16px', borderRadius: '10px', border: '1.5px solid rgba(184,211,207,0.6)', fontSize: '0.95rem', width: '260px', outline: 'none' }}
      />
      <button onClick={() => load()}
        style={{ padding: '12px 28px', borderRadius: '10px', background: '#1E6B68', border: 'none', color: '#fff', fontWeight: '600', cursor: 'pointer' }}>
        Enter
      </button>
    </div>
  );

  const filteredUsers    = users.filter(u => !search || u.email?.includes(search) || u.name?.toLowerCase().includes(search.toLowerCase()));
  const filteredWaitlist = waitlist.filter(w => !search || w.email?.includes(search) || w.name?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ minHeight: '100vh', background: '#f5f8f7', padding: '32px 20px' }}>
      {/* Header */}
      <div style={{ maxWidth: '1000px', margin: '0 auto 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <p style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.3rem', color: '#1E6B68', margin: 0 }}>HYPSEYA Admin</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          <a href="/admin/analytics" style={{ background: '#1E6B68', border: 'none', borderRadius: '8px', padding: '6px 14px', color: '#fff', fontSize: '0.8rem', cursor: 'pointer', textDecoration: 'none', fontWeight: '600' }}>
            Analytics →
          </a>
          <button onClick={() => setAuthed(false)} style={{ background: 'none', border: '1px solid rgba(184,211,207,0.6)', borderRadius: '8px', padding: '6px 14px', color: '#9AADAB', fontSize: '0.8rem', cursor: 'pointer' }}>
            Lock
          </button>
        </div>
      </div>

      {/* Stats bar */}
      {stats && (
        <div style={{ maxWidth: '1000px', margin: '0 auto 24px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {[
            { label: 'Total users',      value: stats.total_users },
            { label: 'Onboarded',        value: stats.onboarded },
            { label: 'Marketing opt-in', value: stats.marketing_opted_in },
            { label: 'Waitlist',         value: stats.waitlist },
            { label: 'Sessions',         value: stats.total_sessions },
          ].map(s => (
            <div key={s.label} style={{
              flex: '1 0 120px', background: '#fff', borderRadius: '12px',
              padding: '16px 20px', border: '1px solid rgba(184,211,207,0.3)',
              boxShadow: '0 1px 6px rgba(30,107,104,0.05)'
            }}>
              <p style={{ margin: '0 0 4px', fontSize: '0.7rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: '#9AADAB', fontWeight: '700' }}>{s.label}</p>
              <p style={{ margin: 0, fontSize: '1.6rem', fontWeight: '700', color: '#1E6B68' }}>{s.value}</p>
            </div>
          ))}
        </div>
      )}

      {/* Tabs + search */}
      <div style={{ maxWidth: '1000px', margin: '0 auto 16px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
        {['users', 'waitlist'].map(t => (
          <button key={t} onClick={() => setTab(t)}
            style={{ padding: '8px 20px', borderRadius: '20px', border: 'none', cursor: 'pointer',
              background: tab === t ? '#1E6B68' : 'rgba(255,255,255,0.88)',
              color: tab === t ? '#fff' : '#9AADAB', fontWeight: '600', fontSize: '0.82rem',
              textTransform: 'capitalize'
            }}>
            {t} ({t === 'users' ? users.length : waitlist.length})
          </button>
        ))}
        <input
          type="text" placeholder="Search name or email…" value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ marginLeft: 'auto', padding: '8px 14px', borderRadius: '20px', border: '1px solid rgba(184,211,207,0.5)', fontSize: '0.82rem', outline: 'none', minWidth: '200px' }}
        />
      </div>

      {/* Table */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', background: '#fff', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(184,211,207,0.3)', boxShadow: '0 2px 16px rgba(30,107,104,0.06)' }}>
        {loading ? (
          <p style={{ padding: '40px', textAlign: 'center', color: '#9AADAB' }}>Loading…</p>
        ) : tab === 'users' ? (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Name', 'Email', 'Signed up', 'Sessions', 'Onboarded', 'Marketing'].map(h => (
                  <th key={h} style={hcell}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((u, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : 'rgba(184,211,207,0.04)' }}>
                  <td style={cell}>{u.name || '—'}</td>
                  <td style={cell}>{u.email}</td>
                  <td style={cell}>{u.created_at ? new Date(u.created_at).toLocaleDateString('en-GB') : '—'}</td>
                  <td style={{ ...cell, textAlign: 'center' }}>{u.session_count ?? 0}</td>
                  <td style={{ ...cell, textAlign: 'center' }}>{u.has_completed_onboarding ? '✓' : '—'}</td>
                  <td style={{ ...cell, textAlign: 'center', color: u.marketing_consent ? '#1E6B68' : '#ccc' }}>
                    {u.marketing_consent ? '✓' : '—'}
                  </td>
                </tr>
              ))}
              {filteredUsers.length === 0 && (
                <tr><td colSpan={6} style={{ ...cell, textAlign: 'center', color: '#ccc' }}>No users found.</td></tr>
              )}
            </tbody>
          </table>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Name', 'Email', 'Date', 'Integrating'].map(h => (
                  <th key={h} style={hcell}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredWaitlist.map((w, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : 'rgba(184,211,207,0.04)' }}>
                  <td style={cell}>{w.name}</td>
                  <td style={cell}>{w.email}</td>
                  <td style={cell}>{w.created_at ? new Date(w.created_at).toLocaleDateString('en-GB') : '—'}</td>
                  <td style={{ ...cell, maxWidth: '280px', color: '#7A9E9B', fontStyle: 'italic' }}>{w.intention || '—'}</td>
                </tr>
              ))}
              {filteredWaitlist.length === 0 && (
                <tr><td colSpan={4} style={{ ...cell, textAlign: 'center', color: '#ccc' }}>No waitlist entries.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
